import { FETCH_AUTOCOMPLETE } from '../constants/actionTypes.js';
import * as api from '../api/index.js';

export const getAutocomplete = () => async (dispatch) => {
  try {    
    console.log('GETTING');
    
    const { data } = await api.fetchAutocomplete();
    // console.log(data);

    dispatch({ type: FETCH_AUTOCOMPLETE, payload: data });

  } catch (error) {
    console.log(error.message);
  }
};